import Vue from "vue";
import Ripple from "@/utils/ripple/ripple";
import "@/utils/ripple/ripple.css";
// 波浪纹
Vue.directive("ripple", Ripple as any);

// 剪切板
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
